(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("QiscusSDKCore", [], factory);
	else if(typeof exports === 'object')
		exports["QiscusSDKCore"] = factory();
	else
		root["QiscusSDKCore"] = factory();
})(window, function() {
return 